import { render, staticRenderFns } from "./BasicDashboardStorages.vue?vue&type=template&id=525179f0&lang=true"
import script from "./BasicDashboardStorages.vue?vue&type=script&lang=js"
export * from "./BasicDashboardStorages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports